import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import { EMPTY_VALUE_INDICATOR, isNotNullValue } from 'framework/utils';
import { highlightMatches, useSearchHighlight } from 'framework/ui/searchHighlight';
import { FieldLayoutProps } from '../../field';
import { fieldWrapperSx } from 'framework/ui/styles';

const LabeledFieldLayout = ({
  label,
  value,
  isColumnDirection = false,
  className,
}: FieldLayoutProps<string | number | React.ReactElement | React.ReactElement[]>) => {
  const searchQuery = useSearchHighlight();

  return (
    <Box
      className={clsx('field__wrapper', className, {
        'field__wrapper--column': isColumnDirection,
      })}
      sx={fieldWrapperSx}
    >
      {label && (
        <Typography className="field-label" variant="body1" component="h3">
          {label as any}
        </Typography>
      )}
      <Typography variant="body1" component="div">
        {isNotNullValue(value) ? highlightMatches(value, searchQuery) : EMPTY_VALUE_INDICATOR}
      </Typography>
    </Box>
  );
};

export default LabeledFieldLayout;
